import React from 'react'

function SortMenu({
                sortDropdownRef,
                sortDropdownOpen,
                toggleSortDropdown,
                selectedSortOption,
                selectSortOption,
                checkedOption,
                appSettings,
        }) {
  return (
    <>

     <div className="top-filter-client-sort">
            <div className="custom-dropdown">
              <div
                ref={sortDropdownRef}
                className={`custom-dropdown-user-new-outer custom-dropdown-select ${sortDropdownOpen ? "open" : ""
                  }`}
              >
                <div
                  className="selected-option custom-dropdown-user-new"
                  onClick={toggleSortDropdown}
                >
                  <div className="center-sort">
                    {selectedSortOption
                      ? global.config.locate(
                        appSettings && appSettings.language,
                        selectedSortOption
                      )
                      : appSettings && appSettings.language
                        ? global.config.locate(appSettings.language, "Sort By")
                        : null}
                  </div>
                </div>
                {sortDropdownOpen && (
                  <div className="custom-dropdown-new">
                    <ul className="type-list">
                      <li
                        className={
                          checkedOption === "By name: A - Z" ? "selected" : ""
                        }
                        onClick={() => selectSortOption("By name: A - Z")}
                      >
                        <span
                          className={`checkbox ${checkedOption === "By name: A - Z" ? "checked" : ""
                            }`}
                        ></span>
                        {global.config.locate(
                          appSettings && appSettings.language,
                          "By name: A - Z"
                        )}
                      </li>
                      <li
                        className={
                          checkedOption === "By name: Z - A" ? "selected" : ""
                        }
                        onClick={() => selectSortOption("By name: Z - A")}
                      >
                        <span
                          className={`checkbox ${checkedOption === "By name: Z - A" ? "checked" : ""
                            }`}
                        ></span>
                        {global.config.locate(
                          appSettings && appSettings.language,
                          "By name: Z - A"
                        )}
                      </li>
                      <li
                        className={
                          checkedOption === "Date: old to new" ? "selected" : ""
                        }
                        onClick={() => selectSortOption("Date: old to new")}
                      >
                        <span
                          className={`checkbox ${checkedOption === "Date: old to new"
                            ? "checked"
                            : ""
                            }`}
                        ></span>
                        {global.config.locate(
                          appSettings && appSettings.language,
                          "Date: old to new"
                        )}
                      </li>
                      <li
                        className={
                          checkedOption === "Date: new to old" ? "selected" : ""
                        }
                        onClick={() => selectSortOption("Date: new to old")}
                      >
                        <span
                          className={`checkbox ${checkedOption === "Date: new to old"
                            ? "checked"
                            : ""
                            }`}
                        ></span>
                        {global.config.locate(
                          appSettings && appSettings.language,
                          "Date: new to old"
                        )}
                      </li>
                      {/* Add more sorting options as needed */}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
      
    </>
  )
}

export default SortMenu
